module.exports = "https://cdn-shared.mathletics.com/teacher-modules/internal-course-manager/44assets/fonts/c4a4c80f873f506fade7af570a8e42be.svg";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome-sass/assets/fonts/font-awesome/fontawesome-webfont.svg?v=4.7.0
// module id = 797
// module chunks = 4